import theme from '../../../../theme';

const getRowStyles = () => ({
  fontSize: '11px',
  fontFamily: theme.typography.fonts.default,
});

export default getRowStyles;
